module.exports = __webpack_public_path__ + "img/oxford-library-logo.67f0a8cd.jpg";